import { defineMessage, useIntl } from 'react-intl';
import { ArrowLargeRight32 } from '@packages/themes/icons';
import type { ButtonProps } from '@mui/material';
import {
  useTracking,
  type GlycerinButtonClickPayload,
  type GlycerinFormSubmitClickPayload,
  type GTMEventGlycerinFormSubmitClick,
  type GTMEventGlycerinButtonClick,
} from '@packages/tracking';
import { Button } from '../Button';

export type LoginButtonProps = ButtonProps & {
  clickTrackingProps?:
    | Omit<GlycerinButtonClickPayload, 'label'>
    | Omit<GlycerinFormSubmitClickPayload, 'label'>;
};

const loginLabel = defineMessage({
  id: 'slot.account.login',
  defaultMessage: 'Anmelden',
});

export const LoginButton: React.FC<LoginButtonProps> = ({
  clickTrackingProps,
  onClick,
  ...props
}) => {
  const { formatMessage } = useIntl();
  const dispatchGTMEvent = useTracking();
  const { href, type } = props;
  const { category, target, detail, placement, variantIds, custom } = clickTrackingProps ?? {};

  return (
    <Button
      onClick={(event) => {
        if (type === 'submit') {
          dispatchGTMEvent<GTMEventGlycerinFormSubmitClick>({
            event: 'FormSubmitClick',
            FormSubmitClickData: {
              category: category ?? 'form-submit-click',
              target: target ?? href,
              detail: detail ?? 'Login Button click',
              label: formatMessage(loginLabel),
              placement,
              formId:
                clickTrackingProps && 'formId' in clickTrackingProps
                  ? clickTrackingProps.formId
                  : undefined,
              variantIds,
              custom,
            },
          });
        } else {
          dispatchGTMEvent<GTMEventGlycerinButtonClick>({
            event: 'ButtonClick',
            ButtonClickData: {
              category: category ?? 'button-click',
              target: target ?? href,
              detail: detail ?? 'Login Button click',
              label: formatMessage(loginLabel),
              placement,
              variantIds,
              custom,
            },
          });
        }
        if (onClick) {
          onClick(event);
        }
      }}
      {...props}
      endIcon={<ArrowLargeRight32 />}
      color="primary"
    >
      {formatMessage(loginLabel)}
    </Button>
  );
};
